import {IterativeSystem} from "tick-knock";
import {CapitalView} from "@game/coregame/view/CapitalView";
import {Building} from "@game/coregame/ecs/entities/Building";
import {StateShapeView} from "@game/coregame/view/StateShapeView";

export class UpdateSkinsSystem extends IterativeSystem {
    constructor() {
        super(e => e.hasAny(CapitalView, StateShapeView));
    }
    protected updateEntity(entity: Building, dt: number) {
        entity.updateAllSkins();
    }

    public update(dt = 0) {
        super.update(dt);
        this.engine.removeSystem(this);
    }
}
